// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrencyValue_container___8LEc","mute":"CurrencyValue_mute__z0bH4","value":"CurrencyValue_value__GNme7","strong":"CurrencyValue_strong__DBeOB"};